import React from 'react'
import PropTypes from 'prop-types'

import config from '@/config'
import lang from '@/lang'
import SelectInput from '../select-input/select-input'

const CountryInput = (props) => {
  const {
    value = config.defaultCountryAsISO2,
    isInline = false,
    onChange,
    includeCodeInLabel = false,
    useFormik,
    readOnly,
    menuPlacement,
    maxMenuHeight,
    className,
    dataQsId,
    label = lang.countryLabel,
    customClassLabel,
    // passed on to SelectInput, e.g. for the dropdowns of the new brand design
    styles,
    customComponents,
  } = props

  let selectOptions = config.countries

  if (includeCodeInLabel) {
    selectOptions = config.countries.map((info) => ({ ...info, label: `${info.label} (${info.iso2})` }))
  }

  const countrySelectProps = {
    label,
    name: 'countryIso',
    value,
    isInline,
    allowCreate: false,
    notAsync: true,
    placeholder: lang.countryPlaceholder,
    options: selectOptions,
    handleChange: onChange,
    customSelectOptions: {
      valueKey: 'iso2',
      labelKey: 'label',
      clearable: false,
      backspaceRemoves: false,
      menuPlacement,
      maxMenuHeight,
    },
    useFormik,
    readOnly,
    styles,
    customComponents,
  }
  return (
    <SelectInput
      dataQsId={dataQsId}
      className={className}
      customClassLabel={customClassLabel}
      {...countrySelectProps} />
  )
}

CountryInput.propTypes = {
  value: PropTypes.string,
  isInline: PropTypes.bool,
  includeCodeInLabel: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  menuPlacement: PropTypes.string,
  maxMenuHeight: PropTypes.number,
  dataQsId: PropTypes.string,
  customClassLabel: PropTypes.string,
  styles: PropTypes.object,
  customComponents: PropTypes.object,
}

export default CountryInput
